import { IReportBase } from './reports-base.model';

export class IReportItem extends IReportBase {
    reportUrl:string;
    createdBy:string;
    createdDate:string;
    reportStatus:number;
    errorMessage:string;
    toolTipSearchByDelay: number;
    toolTipStatusDelay: number;
    projectName:string;
    get IsCIListReport():boolean{
        return this.reportName == 'cilistreport';
    }
    get IsEndCreditsReport():boolean{
        return this.reportName == 'endCreditsReport';
    }
}